import { LicenseMainFormBaseDataProvider } from './LicenseMainFormBaseDataProvider';
import { CompanyLicenseInformation } from '../../types/CompanyLicenseInformation';

export class LicenseMainFormGzDataProvider extends LicenseMainFormBaseDataProvider {
  public async getCompanyLicenseInformation(editedCompanyId?: string | null): Promise<CompanyLicenseInformation> {
    const companyLicenseInfo = await this.dependencies.api.clients.Company.GetCompanyLicenseInformation(
      editedCompanyId || null
    ).toPromise();

    if (!companyLicenseInfo) {
      throw new Error('No company license information data received');
    }

    return companyLicenseInfo;
  }
}
